<div class="loading-spinner" *ngIf="loadingPortal" role="alert">
    <div class="spinner-backdrop" aria-label="Loading, please wait"></div>
    <div class="spinner">
        <div></div>
        <div></div>
    </div>
    <div class="loading-text">Loading..</div>
</div>
<div class="loading-spinner" *ngIf="loadingPDF" role="alert">
    <div class="spinner-backdrop" aria-label="Loading, please wait"></div>
    <div class="spinner">
        <div></div>
        <div></div>
    </div>
    <div class="loading-text">Loading..</div>
</div>
<div class="loading-spinner" *ngIf="loadingConsumer" role="alert">
    <div class="spinner-backdrop" aria-label="Loading, please wait"></div>
    <div class="spinner">
        <div></div>
        <div></div>
    </div>
    <div class="loading-text">Loading..</div>
</div>
<div class="loading-spinner" *ngIf="loadingIpad" role="alert">
    <div class="spinner-backdrop" aria-label="Loading, please wait"></div>
    <div class="spinner">
        <div></div>
        <div></div>
    </div>
    <div class="loading-text">Loading..</div>
</div>

<div class="row">
    <div class="col-24">
        <h1>Search Enrollments</h1>
    </div>
</div>
<button #focusableEleTop class="focusable-element"></button>
<div class="row">
    <div class="col-24" *ngIf="!validForm">
        <div class="alert danger">
            <p><em>Error Message:</em></p>
            <ul>
                <li *ngFor="let error of ErrorMessages"><button>{{error}}</button></li>
            </ul>
        </div>
    </div>
</div>
<div class="row" *ngIf="saveSuccess">
    <div class="col-24">
        <div class="alert success">
            <p><em>Thank you!</em></p>
            <ul>
                <li>
                    <p>{{saveSuccess}}</p>
                </li>
            </ul>
        </div>
    </div>
</div>
<form (keydown)="onKeyDown($event, ListValueId.value, Status.value, LeadTypeValue.value)">
    <div class="row">
        <div class="col-8">
            <div class="input-wrapper">
                <ValidatedTextField [label]="'Enter Search Criteria here'"
                    (onValueChange)="fmoModelPortal.searchText = $event">
                </ValidatedTextField>
            </div>
        </div>

        <div class="col-8">
            <div class="input-wrapper wide">
                <label>Filter</label>
                <select #ListValueId>
                    <option *ngFor="let onList of searchList" value={{onList.ListValue}}
                        [selected]="onList.ListValue == 'Medicare Number'">
                        {{onList.ListValue}}
                    </option>
                </select>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-8">
            <div class="input-wrapper wide">
                <label>Status</label>
                <select #Status>
                    <option *ngFor="let status of statusList" value={{status.ListValue}}>
                        {{status.ListValue}}
                    </option>
                </select>
            </div>
        </div>

        <div class="col-8">
            <div class="input-wrapper wide">
                <label>Lead Type</label>
                <select #LeadTypeValue>
                    <option value="All">All</option>
                    <option *ngFor="let leadType of LeadTypes" value={{leadType.SourceCode}}>
                        {{leadType.SourceName}}
                    </option>
                </select>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-8">
            <div class="input-wrapper">
                <label>Start Date</label>
                <JQDatePicker (elementClicked)="fmoModelPortal.StartDate = $event"
                    [selectedDate]="fmoModelPortal.StartDate">
                </JQDatePicker>
            </div>
        </div>
        <div class="col-8">
            <div class="input-wrapper">
                <label>End Date</label>
                <JQDatePicker (elementClicked)="fmoModelPortal.EndDate = $event"
                    [selectedDate]="fmoModelPortal.EndDate">
                </JQDatePicker>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-24">
            <button class="button primary"
                (click)="SearchEnrollment(ListValueId.value, Status.value, LeadTypeValue.value)">Search</button>
        </div>
    </div>
</form>

<div class="row"
    *ngIf="recordsNotFound && consumerRecordsNotFound && iPadRecordsNotFound && LeadTypeValue.value == 'All'">
    <div class="col-24">
        <div class="alert">
            <p><em>No result found</em></p>
        </div>
    </div>
</div>
<div class="row"
    *ngIf="recordsNotFound && (LeadTypeValue.value != 'CONSUMER' && LeadTypeValue.value != 'IPAD' && LeadTypeValue.value != 'All')">
    <div class="col-24">
        <div class="alert">
            <p><em>No result found</em></p>
        </div>
    </div>
</div>
<!--<div class="row" *ngIf="recordsNotFound && (LeadTypeValue.value != 'CONSUMER'  && LeadTypeValue.value != 'All')">
    <div class="col-24">
        <div class="alert">
            <p><em>No result found</em></p>
        </div>
    </div>
</div>-->
<div class="row"
    *ngIf="consumerRecordsNotFound && ((LeadTypeValue.value == 'CONSUMER' || LeadTypeValue.value=='EMAIL') && LeadTypeValue.value != 'All')">
    <div class="col-24">
        <div class="alert">
            <p><em>No result found</em></p>
        </div>
    </div>
</div>
<div class="row" *ngIf="iPadRecordsNotFound && LeadTypeValue.value == 'IPAD' && !recordsNotFound">
    <div class="col-24">
        <div class="alert">
            <p><em>No result found</em></p>
        </div>
    </div>
</div>
<div [hidden]="!showPortalEnrollment">
    <div class="row">
        <div class="col-24">
            <div class="bottom-10"
                [hidden]="enrollmentSearch == null || LeadTypeValue.value == 'IPAD' || (LeadTypeValue.value=='CONSUMER')|| LeadTypeValue.value=='EMAIL'">
                <button id="btnExport" class="button link excel" (click)="onExportPortalEnrollment()">Export to
                    Excel</button>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-24">
            <div class="jqgrid-header-wrap bottom-20"
                [hidden]="enrollmentSearch == null || LeadTypeValue.value == 'IPAD' || (LeadTypeValue.value=='CONSUMER') || LeadTypeValue.value=='EMAIL'">
                <h2>Portal Enrollment</h2>
                <jqxGrid theme="web" [width]="1238" [columnsautoresize]="true" [autoheight]="true" [virtualmode]="true"
                    [rendergridrows]="renderPortalGridRows" [source]="dataAdapter" [columns]="columns" [pageable]="true"
                    [pagesizeoptions]="[20, 50, 100]" [pagesize]="50" [sortable]="true" (onSort)="onSortPortal($event)"
                    [autoshowcolumnsmenubutton]="false" [editable]="true" #gridReference [filterable]="true"
                    (onCellendedit)="cellEndEditEvent($event)" (onPagesizechanged)="onPortalPageSizeChanged($event)"
                    (onCellclick)="CellclickOnEdit($event)" [columnsresize]="true" [ready]="ready"
                    [selectionmode]="'multiplecellsadvanced'" [updatefilterconditions]="updatefilterconditions"
                    (onFilter)="onFilter($event)" (onRowclick)="OnRowClick($event)">
                </jqxGrid>
            </div>
        </div>
    </div>
</div>
<div [hidden]="!showConsumerEnrollment">
    <div class="row">
        <div class="col-24">
            <div class="bottom-10"
                [hidden]="enrollmentConsumerSearch == null || (LeadTypeValue.value != 'CONSUMER' && LeadTypeValue.value != 'All' && LeadTypeValue.value != 'EMAIL') ">
                <button id="btnExport" class="button link excel" (click)="onExportConsumerEnrollment()">Export to
                    Excel</button>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-24">
            <div class="jqgrid-header-wrap bottom-20"
                [hidden]="enrollmentConsumerSearch == null || (LeadTypeValue.value != 'CONSUMER' && LeadTypeValue.value != 'All' && LeadTypeValue.value != 'EMAIL') ">
                <h2>Consumer Enrollment</h2>
                <jqxGrid [width]="1238" [autoheight]="true" [virtualmode]="true"
                    [rendergridrows]="renderConsumerGridRows" [source]="dataAdapter2" [columns]="columns2"
                    [pageable]="true" [pagesizeoptions]="[20, 50, 100]" [pagesize]="50" [sortable]="true"
                    (onSort)="onSortConsumer($event)" [columnsresize]="true" [autoshowcolumnsmenubutton]="false"
                    (onPagesizechanged)="onConsumerPageSizeChanged($event)" [ready]="ready2"
                    (onCellclick)="CellclickOnEdit($event)" #gridReference2 [filterable]="true"
                    [selectionmode]="'multiplecellsadvanced'" [updatefilterconditions]="updateConsumerfilterconditions"
                    (onFilter)="onConsumerFilter($event)" (onRowclick)="OnRowClick($event)">
                </jqxGrid>
            </div>
        </div>
    </div>
</div>
<div [hidden]="!showIPADEnrollment">
    <div class="row">
        <div class="col-24">
            <div class="bottom-10"
                [hidden]="enrollmentIpadSearch == null ||(LeadTypeValue.value != 'IPAD' && LeadTypeValue.value != 'All')  ">
                <button id="btnExport" class="button link excel" (click)="onExportIPadEnrollment()">Export to
                    Excel</button>
            </div>
        </div>
    </div>

    <div class="row" *ngIf="hideIpad">
        <div class="col-24">
            <div class="jqgrid-header-wrap bottom-20"
                [hidden]="enrollmentIpadSearch == null || (LeadTypeValue.value != 'IPAD' && LeadTypeValue.value != 'All') ">
                <h2>Ipad Enrollment</h2>
                <jqxGrid [width]="1238" [virtualmode]="true" [source]="dataAdapter1"
                    [rendergridrows]="renderIPadGridRows" [columns]="columns1" [pageable]="true"
                    [pagesizeoptions]="[20, 50, 100]" [pagesize]="50" [sortable]="true" (onSort)="onSortIPad($event)"
                    [columnsresize]="true" [autoshowcolumnsmenubutton]="false"
                    (onPagesizechanged)="onIPadPageSizeChanged($event)" (onCellendedit)="cellEndEditEvent($event)"
                    (onCellclick)="CellclickOnEdit($event)" #gridReference1 [ready]="ready1" [editable]="true"
                    [selectionmode]="'multiplecellsadvanced'" [filterable]="true"
                    [updatefilterconditions]="updatefilterconditions" (onFilter)="onIPADFilter($event)"
                    (onRowclick)="OnRowClick($event)">
                </jqxGrid>
            </div>
        </div>
    </div>
</div>
<copyto-clipboard [grid]="gridObj" [event]="eventObj"></copyto-clipboard>